import React, { createContext, useContext, useMemo } from 'react';
import { artistInfo, collections, instagramImages } from '../data/site';

const SiteDataContext = createContext(null);

const NAV_LINKS = [
  { name: 'About', path: '/about' },
  { name: 'Artwork', path: '/' },
  { name: 'Commissions', path: '/commissions' },
  { name: 'Exhibitions', path: '/exhibitions' },
  { name: 'Shop', path: '/shop' },
  { name: 'Contact', path: '/contact' },
];

export const SiteDataProvider = ({ children }) => {
  const value = useMemo(
    () => ({
      artistInfo,
      collections,
      instagramImages,
      navLinks: NAV_LINKS,
      isLoading: false,
      error: null,
      reload: () => {},
    }),
    [],
  );

  return <SiteDataContext.Provider value={value}>{children}</SiteDataContext.Provider>;
};

export const useSiteData = () => useContext(SiteDataContext);
